import { render, staticRenderFns } from "./sendWhatsMobile.vue?vue&type=template&id=1b5b2343&scoped=true"
import script from "./sendWhatsMobile.vue?vue&type=script&lang=js"
export * from "./sendWhatsMobile.vue?vue&type=script&lang=js"
import style0 from "./sendWhatsMobile.vue?vue&type=style&index=0&id=1b5b2343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b2343",
  null
  
)

export default component.exports